import script from "./new-view-empty.vue?vue&type=script&setup=true&lang=js"
export * from "./new-view-empty.vue?vue&type=script&setup=true&lang=js"

import "./new-view-empty.vue?vue&type=style&index=0&id=405c6e2a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-405c6e2a"]])

export default __exports__